import { StateUtils } from '@spartacus/core';
import { PAYMENT_BIND_PAYMENT } from '../payment-state';

export const BIND_PAYMENT = '[Payment] Bind Payment';
export const BIND_PAYMENT_SUCCESS = '[Payment] Bind Payment Success';
export const BIND_PAYMENT_FAIL = '[Payment] Bind Payment Fail';

export class BindPayment extends StateUtils.LoaderLoadAction {
  readonly type = BIND_PAYMENT;

  constructor(public payload: string | null) {
    super(PAYMENT_BIND_PAYMENT);
  }
}

export class BindPaymentSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = BIND_PAYMENT_SUCCESS;

  constructor(public payload: string | null) {
    super(PAYMENT_BIND_PAYMENT);
  }
}

export class BindPaymentFail extends StateUtils.LoaderFailAction {
  readonly type = BIND_PAYMENT_FAIL;

  constructor(public payload: unknown) {
    super(PAYMENT_BIND_PAYMENT);
  }
}

export type BindPaymentActions = BindPayment | BindPaymentSuccess | BindPaymentFail;
